import React from 'react';
import PropTypes from 'prop-types';
import { BlockStack, Box, Text } from '@shopify/polaris';
import { BannerTile, STAR_CSS } from './VskPreview';

const FRAME_CSS = `
.star-preview { display: flex; overflow-x: auto; }
/* Without safe, a child wider than the box overflows both sides and the left half is unreachable. */
.star-preview { justify-content: safe center; }
.star-preview .star-partner-card-container { width: 948px; flex: none; }
`;

const BannerPreview = ({ values }) => (
  <BlockStack gap="200">
    <Text as="span" variant="bodySm" tone="subdued">Swatch King → top of Partner apps</Text>

    <Box background="bg-surface-secondary" padding="300" borderRadius="200">
      <div className="star-preview star-vsk">
        <style>{STAR_CSS + FRAME_CSS}</style>

        <BannerTile values={values} />
      </div>
    </Box>
  </BlockStack>
);

BannerPreview.propTypes = { values: PropTypes.object.isRequired };

export default BannerPreview;
